import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhomSection() {
  const forWhom = ['Sentís que algo está desalineado pero no podés identificar qué', 'Tenés ansiedad, ruido mental o energía inestable', 'Querés un sistema simple, medible y con acompañamiento', 'Estás listo para 7 días de compromiso real', 'Buscás paz y potencia, no perfección'];
  const notForWhom = ["Buscás un 'hack' sin compromiso", 'Querés resultados sin cambiar hábitos', 'No estás dispuesto a soltar el celular 1 hora antes'];
  return <section id="for-whom" className="py-14 md:py-32 bg-charcoal" data-id="element-89">
      <div className="max-w-5xl mx-auto px-6" data-id="element-90">
        <div className="grid md:grid-cols-2 gap-6 md:gap-12" data-id="element-91">
          {/* ES PARA VOS */}
          <FadeIn direction="right" data-id="element-92">
            <div className="bg-charcoal-dark border border-sand/30 p-8 md:p-10 rounded-sm h-full" data-id="element-93">
              <h3 className="text-2xl font-heading font-bold text-sand mb-8" data-id="element-94">
                Es para vos si:
              </h3>
              <ul className="space-y-6" data-id="element-95">
                {forWhom.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-96">
                    <div className="bg-sand/10 p-1 rounded-sm shrink-0 mt-0.5" data-id="element-97">
                      <CheckIcon className="w-5 h-5 text-sand" data-id="element-98" />
                    </div>
                    <span className="text-offwhite-dim text-lg" data-id="element-99">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NO ES PARA VOS */}
          <FadeIn direction="left" delay={0.2} data-id="element-100">
            <div className="bg-charcoal-dark border border-charcoal-light p-8 md:p-10 rounded-sm h-full opacity-80" data-id="element-101">
              <h3 className="text-2xl font-heading font-bold text-offwhite-dim mb-8" data-id="element-102">
                No es para vos si:
              </h3>
              <ul className="space-y-6" data-id="element-103">
                {notForWhom.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-104">
                    <div className="bg-charcoal-light p-1 rounded-sm shrink-0 mt-0.5" data-id="element-105">
                      <XIcon className="w-5 h-5 text-offwhite-dim" data-id="element-106" />
                    </div>
                    <span className="text-offwhite-dim text-lg" data-id="element-107">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}